<div *ngIf="resultsPageGrid && resultsPageGrid.filtersForm">
  <!-- Loading Indicator -->
  <div *ngIf="gridInProgress" class="d-flex justify-content-center p-3">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <!-- Material Table -->
  <div *ngIf="!gridInProgress && resultsPageGrid" class="responsive-table">
    <table mat-table [dataSource]="resultsPageGrid.dataSource" matSort class="mat-elevation-z1 mat-table mat-small clean-table">
      <!-- Privilege Column -->
      <ng-container matColumnDef="privilege">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Privileges</th>
        <td mat-cell *matCellDef="let element">
          <div (click)="searchByPrivilege(element.privilege)" class="cursor-pointer">
            {{ element.privilege }}
          </div>
        </td>
      </ng-container>

      <!-- Dynamic Role Columns -->
      <ng-container *ngFor="let roleName of roleNames" [matColumnDef]="roleName">
        <th mat-header-cell *matHeaderCellDef>
          <div class="header" (click)="searchByRole(roleName)">
            <span> {{ (userRoles[roleName] && userRoles[roleName][0]['description']) || roleName }}</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let element" class="text-center">
          <div (click)="searchByRole(roleName)" class="cursor-pointer">
            <span class="fa fa-check green" [hidden]="!element[roleName]"></span>
            <span class="fa fa-times red" [hidden]="element[roleName]"></span>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <!-- No Data Message -->
    <div *ngIf="!gridInProgress && resultsPageGrid && resultsPageGrid.dataSource.data.length === 0" class="text-center p-4">
      <p class="text-muted">No records found</p>
    </div>

    <!-- Paginator -->
    <!-- <mat-paginator
      [pageSizeOptions]="[15, 25, 50, 100]"
      [pageSize]="resultsPageGrid.pageSize"
      [length]="resultsPageGrid.total"
      [pageIndex]="resultsPageGrid.pageIndex"
      (page)="resultsPageGrid.onPaginate($event)"
      showFirstLastButtons
    >
    </mat-paginator> -->
  </div>
</div>
